let logTrackerEvents = false;
const track = action => {
    try {
        const payload = {
            hitType: 'pageview',
            page: `${window.location.pathname}/events/${action}`,
            title: action
        };
        if (logTrackerEvents)
            console.log('sending tracker event', payload);
        ga('send', payload);
    } finally {
        // ignore failed tracking, probably an ad blocker.
        return;
    }
};

setTimeout(function () {
    try {
        // Extracting the GA4 client ID from the '_ga' cookie
        var gaCookie = document.cookie.split('; ').find(function (row) {
            return row.startsWith('_ga=');
        });
        if (!gaCookie) {
            console.error("GA4 cookie not found.");
            return;
        }

        var gaCookieValue = gaCookie.split('=')[1];
        var clientIdMatches = /GA\d\.\d\.(.+)/.exec(gaCookieValue);
        if (!clientIdMatches) {
            console.error("Invalid GA4 cookie format.");
            return;
        }

        var clientId = clientIdMatches[1];
        if (!clientId) {
            console.error("GA4 Client ID is empty or undefined.");
            return;
        }

        // Post the extracted client ID to the server
        $.post('/GAMetaInfo/SetGA4ClientID', { gaClientId: clientId })
            .catch(function (err) {
                console.error("Error posting the ClientID: ", err);
            });
    } catch (error) {
        console.error("Unexpected error occurred: ", error);
    }
}, 1600); // 1.6 seconds delay
